<template>
  <div class="mt-4">
    <v-card class="mx-auto" max-width="95%" elevation="2">
      <v-toolbar dark dense>
        <v-toolbar-title>돈만농 · API 테스터 (DEV)</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-chip small outlined dark class="mr-2">
          {{ totalApiCount }} APIs · {{ catalog.length }} 그룹
        </v-chip>
        <v-btn small outlined dark class="mr-2" @click="showSettings = !showSettings">
          <v-icon left small>mdi-cog</v-icon>Base URL/토큰
        </v-btn>
        <v-btn small outlined dark class="mr-2" @click="clearAllStorage" title="저장된 모든 payload/캡처 초기화">
          <v-icon left small>mdi-broom</v-icon>저장 초기화
        </v-btn>
        <v-btn small color="success" depressed class="mr-2" @click="exportDoc" :disabled="checkedCount === 0"
               title="체크된 API 를 요청/응답 포함 마크다운으로 export">
          <v-icon left small>mdi-file-export-outline</v-icon>문서 Export ({{ checkedCount }})
        </v-btn>
      </v-toolbar>

      <!-- Base URL / Bearer 토큰 설정 (접힘) -->
      <v-expand-transition>
        <v-card v-if="showSettings" flat tile color="grey lighten-4">
          <v-card-text class="py-3">
            <v-row dense>
              <v-col cols="12" class="pb-0">
                <span class="text-caption grey--text mr-2">빠른 선택</span>
                <v-btn x-small outlined class="mr-1" @click="setBaseUrl('http://localhost:10012')">로컬(:10012)</v-btn>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="serviceApiUrl"
                  label="게임 API Base URL"
                  outlined dense hide-details
                  prepend-inner-icon="mdi-cloud-outline"
                  hint="돈만농 게임서버 주소를 입력하세요 (예: https://도메인 / 로컬 node 직접: http://localhost:포트)"
                  persistent-hint
                  @blur="saveSettings"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="8">
                <v-text-field
                  v-model="bearerToken"
                  label="access_token (auth API 호출 시 헤더 자동 첨부)"
                  outlined dense hide-details
                  prepend-inner-icon="mdi-key-variant"
                  hint="auth/login 응답 res_data.access_token 자동 캡처. localStorage 보관(DEV 전용)."
                  persistent-hint clearable
                  @blur="saveSettings"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model="userId"
                  label="USER_ID (auth API 바디 자동 주입)"
                  outlined dense hide-details
                  prepend-inner-icon="mdi-account"
                  hint="로그인 시 자동 세팅"
                  persistent-hint clearable
                  @blur="saveSettings"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field v-model="pkg" label="package (헤더)" outlined dense hide-details
                  hint="토큰 네임스페이스" persistent-hint @blur="saveSettings"></v-text-field>
              </v-col>
              <v-col cols="6" sm="3">
                <v-text-field v-model="deviceType" label="device_type" outlined dense hide-details @blur="saveSettings"></v-text-field>
              </v-col>
              <v-col cols="6" sm="3">
                <v-text-field v-model="appVersion" label="app_version" outlined dense hide-details @blur="saveSettings"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" class="d-flex align-center">
                <v-checkbox v-model="masterJs" label="master_js 우회" dense hide-details class="mt-0"
                  @change="saveSettings" title="헤더 master_js:justin — 토큰검증 스킵(개발용)"></v-checkbox>
              </v-col>
              <v-col cols="12" class="text-right">
                <v-btn small outlined @click="showSettings = false">닫기</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-expand-transition>


      <v-row no-gutters>
        <!-- 좌측: API 카탈로그 -->
        <v-col cols="12" md="4" class="pa-3 grey lighten-5" style="border-right:1px solid #eee; min-height:600px">
          <v-text-field
            v-model="keyword"
            label="API 검색"
            outlined dense hide-details clearable
            prepend-inner-icon="mdi-magnify"
            class="mb-3"
          ></v-text-field>

          <div class="mb-2 d-flex align-center flex-wrap">
            <v-btn x-small outlined @click="expandAll" class="mr-1 mb-1">
              <v-icon left x-small>mdi-chevron-double-down</v-icon>펼침
            </v-btn>
            <v-btn x-small outlined @click="collapseAll" class="mr-1 mb-1">
              <v-icon left x-small>mdi-chevron-double-up</v-icon>접기
            </v-btn>
            <v-btn x-small outlined color="primary" @click="checkAll" class="mr-1 mb-1">
              <v-icon left x-small>mdi-checkbox-multiple-marked-outline</v-icon>전체 체크
            </v-btn>
            <v-btn x-small text @click="uncheckAll" class="mb-1">해제</v-btn>
          </div>
          <v-list dense>
            <v-list-group
              v-for="g in filteredCatalog"
              :key="g.group"
              v-model="groupOpen[g.group]"
              :prepend-icon="groupIcon(g.group)"
              no-action
              class="api-group"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium">
                    {{ g.group }}
                    <span class="grey--text text-caption ml-1">({{ g.apis.length }})</span>
                  </v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                v-for="a in g.apis"
                :key="g.group + ':' + a.name"
                @click="selectApi(a)"
                :class="{ 'primary lighten-5': selected && selected.name === a.name }"
                class="pl-4 api-item"
              >
                <v-list-item-icon class="mr-2 my-2" @click.stop>
                  <v-simple-checkbox
                    :value="!!checked[a.name]"
                    color="primary"
                    :ripple="false"
                    @input="toggleCheck(a.name)"
                  ></v-simple-checkbox>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-body-2">
                    <v-icon v-if="a.auth && !bearerToken" x-small color="grey lighten-1">mdi-lock</v-icon>
                    {{ a.label }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-caption">
                    <code style="font-size:11px">{{ a.endpoint }}</code>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action v-if="captured[a.name]">
                  <v-icon small :color="(captured[a.name].status && captured[a.name].status < 400) ? 'green' : 'orange'"
                          :title="'응답 캡처됨 (HTTP ' + captured[a.name].status + ')'">mdi-check-circle</v-icon>
                </v-list-item-action>
                <v-list-item-action v-else-if="hasSavedPayload(a.name)">
                  <v-icon small color="grey lighten-1">mdi-content-save-check-outline</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list-group>
          </v-list>
        </v-col>

        <!-- 우측: payload 편집 + 호출 + 응답 -->
        <v-col cols="12" md="8" class="pa-4">
          <div v-if="!selected" class="text-center py-12 grey--text">
            <v-icon size="64" color="grey lighten-1">mdi-flask-empty-outline</v-icon>
            <p class="mt-3">좌측에서 호출할 API 를 선택하세요.</p>
          </div>

          <div v-else>
            <!-- 헤더 -->
            <v-card outlined class="mb-3">
              <v-card-text class="pb-2">
                <div class="d-flex align-center">
                  <div>
                    <div class="text-h6">
                      {{ selected.label }}
                      <v-icon v-if="selected.auth" small color="orange" class="ml-1" title="Bearer 토큰 필요">mdi-key</v-icon>
                    </div>
                    <div class="text-caption grey--text">
                      [{{ selectedGroup }}] {{ selected.name }}
                    </div>
                    <div class="text-caption mt-1">
                      <code>POST</code> <code>{{ effectiveUrl }}</code>
                    </div>
                    <div v-if="selected.auth && !bearerToken" class="text-caption red--text mt-1">
                      <v-icon x-small color="red">mdi-lock</v-icon>
                      로그인 필요 — 먼저 <b>로그인</b> API 를 호출해 토큰을 받으세요
                    </div>
                  </div>
                  <v-spacer></v-spacer>
                  <v-btn small outlined color="grey" class="mr-2" @click="resetToDefault">
                    <v-icon left small>mdi-restore</v-icon>기본값 복원
                  </v-btn>
                  <v-btn small color="success" depressed class="mr-2" @click="savePayloadLocal">
                    <v-icon left small>mdi-content-save</v-icon>로컬 저장
                  </v-btn>
                  <v-btn small color="primary" depressed :loading="calling" :disabled="!canCallSelected" @click="callApi">
                    <v-icon left small>mdi-send</v-icon>호출
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>

            <!-- payload 편집 -->
            <v-card outlined class="mb-3">
              <v-card-title class="text-subtitle-2 grey lighten-4 pa-2">
                <v-icon left small>mdi-code-json</v-icon>
                Payload (JSON)
                <v-spacer></v-spacer>
                <span class="text-caption grey--text" v-if="payloadValid">
                  <v-icon x-small color="green">mdi-check-circle</v-icon> 유효
                </span>
                <span class="text-caption red--text" v-else>
                  <v-icon x-small color="red">mdi-alert-circle</v-icon> JSON 파싱 오류
                </span>
                <v-btn icon x-small class="ml-2" :disabled="!payloadText" @click="copyToClipboard(payloadText)" title="Payload 복사">
                  <v-icon x-small>mdi-content-copy</v-icon>
                </v-btn>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="pa-0">
                <v-textarea
                  v-model="payloadText"
                  solo flat hide-details
                  rows="14"
                  auto-grow
                  no-resize
                  style="font-family:monospace; font-size:13px"
                  @input="validatePayload"
                ></v-textarea>
              </v-card-text>
              <!-- 파라미터 안내 (허용값/설명). 값 칩 클릭 시 payload 에 자동 적용 -->
              <template v-if="selected.hints && selected.hints.length">
                <v-divider></v-divider>
                <div class="pa-2" style="background:#fafafa">
                  <div class="text-caption grey--text mb-1">
                    <v-icon x-small>mdi-information-outline</v-icon> 파라미터 안내 <span class="grey--text">(값 클릭 시 payload 적용)</span>
                  </div>
                  <div v-for="h in selected.hints" :key="h.key" class="mb-2">
                    <!-- 표(체크박스) 형태: keys 가 있으면 — 행 클릭 시 배열 키 추가/제거 -->
                    <template v-if="h.keys">
                      <div class="text-caption grey--text mb-1">
                        <code style="font-size:12px">{{ h.key }}</code>
                        <span class="ml-1">— 행 클릭 시 추가/제거 (✔ 선택됨 · {{ activeCount(h.key) }}개 선택)</span>
                      </div>
                      <div style="max-height:300px; overflow:auto; border:1px solid #eee; border-radius:4px;">
                        <v-simple-table dense>
                          <tbody>
                            <tr
                              v-for="row in h.keys"
                              :key="row.k"
                              style="cursor:pointer"
                              :style="{ background: isHintValueActive(h.key, row.k) ? '#E3F2FD' : '' }"
                              @click="applyHintValue(h.key, row.k)"
                            >
                              <td style="width:34px; text-align:center; padding:0 4px">
                                <v-icon small :color="isHintValueActive(h.key, row.k) ? 'primary' : 'grey lighten-1'">
                                  {{ isHintValueActive(h.key, row.k) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
                                </v-icon>
                              </td>
                              <td style="width:190px"><code style="font-size:12px">{{ row.k }}</code></td>
                              <td class="text-caption grey--text">{{ row.d }}</td>
                            </tr>
                          </tbody>
                        </v-simple-table>
                      </div>
                    </template>
                    <!-- 칩 형태: values(단순 허용값) — 선택된 값은 채워짐(✔) -->
                    <template v-else>
                      <div class="d-flex align-center flex-wrap">
                        <code class="mr-2" style="font-size:12px">{{ h.key }}</code>
                        <template v-if="h.values">
                          <v-chip
                            v-for="v in h.values"
                            :key="v"
                            x-small
                            color="primary"
                            :outlined="!isHintValueActive(h.key, v)"
                            class="mr-1 my-1"
                            style="cursor:pointer"
                            :title="isHintValueActive(h.key, v) ? '선택됨 — 클릭하면 제거' : '클릭하면 payload 에 적용'"
                            @click="applyHintValue(h.key, v)"
                          >
                            <v-icon v-if="isHintValueActive(h.key, v)" left x-small>mdi-check</v-icon>{{ v }}
                          </v-chip>
                        </template>
                        <span v-if="h.desc" class="text-caption grey--text ml-1">{{ h.desc }}</span>
                      </div>
                    </template>
                  </div>
                </div>
              </template>
            </v-card>

            <!-- 응답 -->
            <v-card outlined>
              <v-card-title class="text-subtitle-2 grey lighten-4 pa-2">
                <v-icon left small>mdi-import</v-icon>
                응답
                <v-spacer></v-spacer>
                <span v-if="responseStatus !== null" class="text-caption">
                  HTTP <v-chip x-small :color="responseStatus < 400 ? 'green' : 'red'" dark class="ml-1">
                    {{ responseStatus }}
                  </v-chip>
                  <span class="ml-2 grey--text">{{ responseTime }}ms</span>
                </span>
                <v-btn icon x-small class="ml-2" :disabled="!responseText" @click="copyToClipboard(responseText)" title="응답 복사">
                  <v-icon x-small>mdi-content-copy</v-icon>
                </v-btn>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="pa-0">
                <pre v-if="responseText" style="margin:0; padding:12px; background:#f5f5f5; font-size:12px; max-height:400px; overflow:auto">{{ responseText }}</pre>
                <div v-else class="pa-6 text-center grey--text text-caption">
                  아직 호출하지 않았습니다.
                </div>
              </v-card-text>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <div class="py-12"></div>
    <v-snackbar v-model="copiedSnack" :timeout="1200" color="success" bottom right>
      <v-icon left small>mdi-content-copy</v-icon> 클립보드에 복사되었습니다.
    </v-snackbar>
  </div>
</template>

<script>
import axios from 'axios'
import config from '../../config/config'
import { SERVICE_API_MANDOORA_CATALOG } from '../../api/service_api_mandoora_catalog'

const LS_PREFIX = 'mandoora_cms:api_tester'

// 테스트 불필요 그룹은 숨김 (Offerwall = 매체 postback 시그니처 전용, 수동 테스트 의미 없음)
const HIDDEN_GROUPS = ['Offerwall']
// 맨 위로 고정할 그룹 (Auth = 로그인 필수 → 항상 최상단)
const TOP_GROUPS = ['Auth']

// Service_API_New 만. 각 api 에 source 표시. 숨김 그룹 제외 + Auth 최상단 정렬.
function buildCatalog() {
  const groups = SERVICE_API_MANDOORA_CATALOG
    .filter(g => !HIDDEN_GROUPS.some(h => g.group.startsWith(h)))
    .map(g => ({
      group: g.group,
      apis: g.apis.map(a => ({ ...a, source: 'service_api' })),
    }))
  // Auth 그룹을 맨 위로 (Array.sort 안정 정렬 → 나머지 그룹은 원래 순서 유지)
  groups.sort((a, b) => {
    const pa = TOP_GROUPS.some(t => a.group.startsWith(t)) ? 0 : 1
    const pb = TOP_GROUPS.some(t => b.group.startsWith(t)) ? 0 : 1
    return pa - pb
  })
  return groups
}

export default {
  name: 'Mandoora_ApiTester',
  data() {
    return {
      catalog: buildCatalog(),
      keyword: '',
      selected: null,
      selectedGroup: '',
      payloadText: '',
      payloadValid: true,
      calling: false,
      responseText: '',
      copiedSnack: false,     // 복사 완료 스낵바
      responseStatus: null,
      responseTime: 0,
      groupOpen: {},                  // 그룹별 펼침 상태
      captured: {},                   // { [apiName]: { request, status, time, response, at } } — 호출 시 자동 캡처
      checked: {},                    // { [apiName]: true } — 문서 export 에 포함할 API
      // 신 게임 API(service_api_v1) base URL + 인증
      serviceApiUrl: '',   // 돈만농 게임서버 주소 미정 — 직접 입력(localStorage 에 기억됨)
      bearerToken: '',        // access_token (auth/login 응답)
      userId: '',             // 로그인 유저 USER_ID (auth API 바디 자동 주입)
      pkg: 'mandoora',     // package 헤더(토큰 네임스페이스) — 실제 앱 패키지로 맞출 것
      deviceUuid: 'CMS_TESTER',
      deviceType: 'TEST',
      appVersion: '1.0.0',
      masterJs: false,        // 개발 우회 헤더 master_js:justin (토큰검증 스킵)
      showSettings: false,
      // 이미지 업로드 테스터
      showUpload: false,
      uploadFiles: [],
      uploading: false,
      uploadResults: [],   // [{ name, ok, url?, error? }]
      uploadedUrls: [],    // 업로드 성공 URL 누적
    }
  },
  computed: {
    totalApiCount() {
      return this.catalog.reduce((s, g) => s + g.apis.length, 0)
    },
    // 현재 payload(JSON)를 객체로 파싱 — 힌트 칩/표의 선택 상태 판정용
    payloadObj() {
      try { return JSON.parse(this.payloadText) || {} } catch (e) { return {} }
    },
    checkedCount() {
      return Object.keys(this.checked).filter(k => this.checked[k]).length
    },
    loggedIn() {
      return !!this.bearerToken
    },
    // auth 필요 API 는 토큰(로그인) 없으면 호출 불가
    canCallSelected() {
      if (!this.selected) return false
      return !(this.selected.auth && !this.bearerToken)
    },
    uploadedUrlsJson() {
      return JSON.stringify(this.uploadedUrls, null, 2)
    },
    effectiveUrl() {
      if (!this.selected) return ''
      return (this.serviceApiUrl || '').replace(/\/$/, '') + this.selected.endpoint
    },
    filteredCatalog() {
      const k = (this.keyword || '').trim().toLowerCase()
      if (!k) return this.catalog
      return this.catalog
        .map(g => ({
          group: g.group,
          apis: g.apis.filter(a =>
            a.name.toLowerCase().includes(k) ||
            a.label.toLowerCase().includes(k) ||
            a.endpoint.toLowerCase().includes(k)
          ),
        }))
        .filter(g => g.apis.length > 0)
    },
  },
  methods: {
    storageKey(apiName) { return `${LS_PREFIX}:payload:${apiName}` },
    expandAll() {
      this.catalog.forEach(g => this.$set(this.groupOpen, g.group, true))
    },
    collapseAll() {
      this.catalog.forEach(g => this.$set(this.groupOpen, g.group, false))
    },
    groupIcon(groupName) {
      const map = {
        '프롬프트':         'mdi-format-list-bulleted',
        '피드':             'mdi-newspaper-variant-multiple-outline',
        '유저':             'mdi-account-details-outline',
        '공지':             'mdi-bullhorn-outline',
        '전면 이벤트':      'mdi-image-multiple-outline',
        '구매 내역':        'mdi-cart-outline',
        '서버 설정':        'mdi-cog-outline',
        '메인 노출 (featured)': 'mdi-star-circle-outline',
      }
      return map[groupName] || 'mdi-folder-outline'
    },
    hasSavedPayload(apiName) {
      try { return !!localStorage.getItem(this.storageKey(apiName)) } catch (e) { return false }
    },
    selectApi(api) {
      this.selected = api
      // group 찾기 + 해당 그룹 자동 펼침
      const g = this.catalog.find(g => g.apis.some(a => a.name === api.name))
      this.selectedGroup = g ? g.group : ''
      if (g) this.$set(this.groupOpen, g.group, true)
      // 저장된 payload 우선, 없으면 defaults
      let payload
      try {
        const saved = localStorage.getItem(this.storageKey(api.name))
        if (saved) payload = JSON.parse(saved)
      } catch (e) { /* ignore */ }
      if (!payload) payload = api.defaults || {}
      // 로그인: 가장 최근 사용한 AUTH_ID(디바이스ID)를 로컬에서 복원 — 사람마다 다른 값 유지(껏다 켜도 보존)
      if (api.name === 'sa_auth_login' && payload && typeof payload === 'object') {
        try {
          const lastAuth = localStorage.getItem(`${LS_PREFIX}:last_auth_id`)
          if (lastAuth) payload.AUTH_ID = lastAuth
        } catch (e) { /* ignore */ }
      }
      // USER_ID 를 페이로드 맨 앞에 노출(로그인 유저로 자동 채움, 직접 수정 가능) — 로그인 제외
      if (api.name !== 'sa_auth_login' && payload && typeof payload === 'object' && payload.USER_ID === undefined) {
        payload = Object.assign({ USER_ID: this.userId || '' }, payload)
      }
      this.payloadText = JSON.stringify(payload, null, 2)
      this.payloadValid = true
      // 이전에 캡처한 응답이 있으면 복원 (없으면 비움)
      const cap = this.captured[api.name]
      this.responseText = cap ? cap.response : ''
      this.responseStatus = cap ? cap.status : null
      this.responseTime = cap ? cap.time : 0
      try { localStorage.setItem(`${LS_PREFIX}:last_api`, api.name) } catch (e) { /* ignore */ }
    },
    resetToDefault() {
      if (!this.selected) return
      let payload = this.selected.defaults || {}
      if (this.selected.name !== 'sa_auth_login' && payload.USER_ID === undefined) {
        payload = Object.assign({ USER_ID: this.userId || '' }, payload)
      }
      this.payloadText = JSON.stringify(payload, null, 2)
      this.validatePayload()
    },
    validatePayload() {
      try {
        JSON.parse(this.payloadText)
        this.payloadValid = true
      } catch (e) {
        this.payloadValid = false
      }
    },
    // 힌트 값이 현재 payload 에 선택돼 있는지 (배열이면 포함 여부, 스칼라면 일치)
    isHintValueActive(key, value) {
      const cur = this.payloadObj[key]
      if (Array.isArray(cur)) return cur.indexOf(value) >= 0
      return cur === value
    },
    // 배열 키의 현재 선택 개수
    activeCount(key) {
      const cur = this.payloadObj[key]
      if (Array.isArray(cur)) return cur.length
      return (cur !== undefined && cur !== '' && cur !== null) ? 1 : 0
    },
    // 파라미터 안내 칩/표 클릭 → 현재 payload 의 해당 키에 값 적용(배열이면 토글)
    applyHintValue(key, value) {
      let obj
      try { obj = JSON.parse(this.payloadText) } catch (e) { obj = {} }
      if (Array.isArray(obj[key])) {
        // 배열 키(예: FETCH_KEYS): 값 토글 — 있으면 제거, 없으면 추가
        const idx = obj[key].indexOf(value)
        if (idx >= 0) obj[key].splice(idx, 1)
        else obj[key].push(value)
      } else {
        obj[key] = value
      }
      this.payloadText = JSON.stringify(obj, null, 2)
      this.validatePayload()
    },
    // 페이로드/응답 클립보드 복사
    copyToClipboard(text) {
      const s = (text == null ? '' : String(text))
      const done = () => { this.copiedSnack = true }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(s).then(done).catch(() => this.fallbackCopy(s, done))
      } else {
        this.fallbackCopy(s, done)
      }
    },
    fallbackCopy(s, done) {
      const ta = document.createElement('textarea')
      ta.value = s; ta.style.position = 'fixed'; ta.style.opacity = '0'
      document.body.appendChild(ta); ta.select()
      try { document.execCommand('copy'); done() } catch (e) { /* noop */ }
      document.body.removeChild(ta)
    },
    savePayloadLocal() {
      if (!this.selected) return
      try {
        const obj = JSON.parse(this.payloadText)
        localStorage.setItem(this.storageKey(this.selected.name), JSON.stringify(obj))
        this.$nextTick(() => this.$forceUpdate())
        alert('로컬에 저장되었습니다. 다음 진입 시 자동 복원됩니다.')
      } catch (e) {
        alert('JSON 파싱 오류 — 저장 실패')
      }
    },
    setBaseUrl(url) {
      this.serviceApiUrl = url
      this.saveSettings()
    },
    saveSettings() {
      try {
        localStorage.setItem(`${LS_PREFIX}:service_api_url`, this.serviceApiUrl || '')
        localStorage.setItem(`${LS_PREFIX}:bearer_token`,    this.bearerToken   || '')
        localStorage.setItem(`${LS_PREFIX}:auth_extra`, JSON.stringify({
          userId: this.userId, pkg: this.pkg, deviceUuid: this.deviceUuid,
          deviceType: this.deviceType, appVersion: this.appVersion, masterJs: this.masterJs,
        }))
      } catch (e) { /* ignore */ }
    },
    loadSettings() {
      try {
        const s = localStorage.getItem(`${LS_PREFIX}:service_api_url`)
        const b = localStorage.getItem(`${LS_PREFIX}:bearer_token`)
        if (s) this.serviceApiUrl = s
        if (b) this.bearerToken   = b
        const ex = localStorage.getItem(`${LS_PREFIX}:auth_extra`)
        if (ex) {
          const p = JSON.parse(ex)
          if (p && typeof p === 'object') {
            if (p.userId != null) this.userId = p.userId
            if (p.pkg) this.pkg = p.pkg
            if (p.deviceUuid) this.deviceUuid = p.deviceUuid
            if (p.deviceType) this.deviceType = p.deviceType
            if (p.appVersion) this.appVersion = p.appVersion
            if (typeof p.masterJs === 'boolean') this.masterJs = p.masterJs
          }
        }
      } catch (e) { /* ignore */ }
    },
    clearAllStorage() {
      if (!confirm('저장된 모든 API payload 를 삭제하시겠습니까?')) return
      try {
        const keys = []
        for (let i = 0; i < localStorage.length; i++) {
          const k = localStorage.key(i)
          if (k && k.startsWith(LS_PREFIX)) keys.push(k)
        }
        keys.forEach(k => localStorage.removeItem(k))
        this.captured = {}
        this.checked = {}
        this.$forceUpdate()
        alert(`${keys.length}개 항목 삭제됨`)
      } catch (e) {
        alert('초기화 실패: ' + e.message)
      }
    },
    // ── 체크 (문서 export 대상) ──
    toggleCheck(name) {
      this.$set(this.checked, name, !this.checked[name])
      this.persistChecked()
    },
    checkAll() {
      this.catalog.forEach(g => g.apis.forEach(a => this.$set(this.checked, a.name, true)))
      this.persistChecked()
    },
    uncheckAll() {
      this.checked = {}
      this.persistChecked()
    },
    persistChecked() {
      try { localStorage.setItem(`${LS_PREFIX}:checked`, JSON.stringify(this.checked)) } catch (e) { /* ignore */ }
    },
    // ── 응답 캡처 (호출 시 자동) ──
    captureResponse() {
      if (!this.selected) return
      this.$set(this.captured, this.selected.name, {
        request: this.payloadText,
        status: this.responseStatus,
        time: this.responseTime,
        response: this.responseText,
        at: new Date().toISOString(),
      })
      try { localStorage.setItem(`${LS_PREFIX}:captured`, JSON.stringify(this.captured)) } catch (e) { /* ignore */ }
      // 호출했으면 export 대상으로 자동 체크
      if (!this.checked[this.selected.name]) {
        this.$set(this.checked, this.selected.name, true)
        this.persistChecked()
      }
    },
    // ── 마크다운 문서 export (체크된 API 의 요청/응답) ──
    tsForFile() {
      const d = new Date(); const p = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}${p(d.getMonth() + 1)}${p(d.getDate())}_${p(d.getHours())}${p(d.getMinutes())}`
    },
    exportDoc() {
      const out = []
      out.push('# 돈만농 API 테스트 결과', '')
      out.push(`- Base URL: \`${this.serviceApiUrl}\``)
      out.push(`- 생성: ${new Date().toLocaleString()}`)
      out.push(`- 포함 API: ${this.checkedCount}개`, '')
      let n = 0
      for (const g of this.catalog) {
        const picked = g.apis.filter(a => this.checked[a.name])
        if (!picked.length) continue
        out.push(`## ${g.group}`, '')
        for (const a of picked) {
          n += 1
          const cap = this.captured[a.name]
          out.push(`### ${a.label} \`${a.name}\``, '')
          out.push(`\`POST\` \`${a.endpoint}\` · auth: ${a.auth ? '필요' : '불필요'}`, '')
          out.push('**Request**', '```json', cap ? cap.request : JSON.stringify(a.defaults || {}, null, 2), '```', '')
          if (cap) {
            out.push(`**Response** (HTTP ${cap.status}, ${cap.time}ms)`, '```json', cap.response, '```', '')
          } else {
            out.push('**Response** — _아직 호출 안 함_', '')
          }
        }
      }
      if (!n) { alert('체크된 API 가 없습니다.'); return }
      const blob = new Blob([out.join('\n')], { type: 'text/markdown;charset=utf-8' })
      const url = URL.createObjectURL(blob)
      const el = document.createElement('a')
      el.href = url
      el.download = `mandoora_api_test_${this.tsForFile()}.md`
      document.body.appendChild(el); el.click(); document.body.removeChild(el)
      URL.revokeObjectURL(url)
    },
    async callApi() {
      if (!this.selected) return
      let payload
      try {
        payload = JSON.parse(this.payloadText)
      } catch (e) {
        alert('JSON 파싱 오류 — payload 를 확인하세요.')
        return
      }
      this.calling = true
      // 로그인: 사용한 AUTH_ID(디바이스ID)를 로컬에 저장 — 껏다 켜도 복원(사람마다 다른 값 유지)
      if (this.selected.name === 'sa_auth_login' && payload && typeof payload === 'object' && payload.AUTH_ID) {
        try { localStorage.setItem(`${LS_PREFIX}:last_auth_id`, String(payload.AUTH_ID)) } catch (e) { /* ignore */ }
      }
      this.responseText = ''
      this.responseStatus = null
      const t0 = Date.now()
      try {
        // 게임 API 로 보낼 헤더 (신 API: package/device_* 필수, 언더스코어 헤더)
        const gameHeaders = {
          package: this.pkg,
          device_uuid: this.deviceUuid,
          device_type: this.deviceType,
          app_version: this.appVersion,
        }
        if (this.masterJs) gameHeaders.master_js = 'justin'
        if (this.selected.auth && this.bearerToken) gameHeaders.access_token = this.bearerToken
        // 로그인 외 엔드포인트엔 USER_ID 를 로그인 유저로 자동 주입 (public 이라도 USER_ID 필요한 것 대비, 이미 있으면 유지)
        if (this.selected.name !== 'sa_auth_login' && this.userId && payload && typeof payload === 'object'
            && payload.USER_ID === undefined) {
          payload = { USER_ID: this.userId, ...payload }
        }
        // 프론트 → cms_back 프록시 → 게임 API (CORS 우회, 서버-대-서버 포워딩)
        const proxyUrl = config.getBackendUrl + '/api/mandoora/api_tester/proxy'
        const res = await axios.post(proxyUrl, {
          base_url: this.serviceApiUrl,
          path: this.selected.endpoint,
          headers: gameHeaders,
          body: payload,
        })
        const env = res.data || {}
        if (env.err_code) {
          // cms_back 프록시 자체 오류
          this.responseStatus = 0
          this.responseText = 'CMS 백엔드 프록시 오류: ' + (env.err_message || env.err_code)
        } else if (env.error) {
          // cms_back → 게임 API 연결 실패
          this.responseStatus = 0
          this.responseText = '게임 API 연결 실패: ' + env.error
        } else {
          this.responseStatus = env.http_status
          const gameBody = env.body
          this.responseText = (typeof gameBody === 'string') ? gameBody : JSON.stringify(gameBody, null, 2)
          // auth/login 응답이면 access_token + user_id 자동 캡처
          if (this.selected.name === 'sa_auth_login' && gameBody && typeof gameBody === 'object') {
            const rd = gameBody.res_data || {}
            const t = rd.access_token || gameBody.access_token
            const uid = rd.user_id || gameBody.user_id
            if (t) this.bearerToken = t
            if (uid) this.userId = uid
            this.saveSettings()
          }
        }
      } catch (e) {
        this.responseStatus = (e.response && e.response.status) || 0
        const body = e.response && e.response.data
        this.responseText = body
          ? JSON.stringify(body, null, 2)
          : `Error: ${e.message || e}`
      } finally {
        this.responseTime = Date.now() - t0
        this.calling = false
        this.captureResponse()   // 요청/응답 캡처 + export 대상 자동 체크
      }
    },
  },
  watch: {
    // 그룹 펼침 상태 변경 시 localStorage 저장
    groupOpen: {
      deep: true,
      handler(v) {
        try { localStorage.setItem(`${LS_PREFIX}:group_open`, JSON.stringify(v)) } catch (e) { /* ignore */ }
      },
    },
  },
  mounted() {
    // base URL + bearer 토큰 복원
    this.loadSettings()
    // 캡처 응답 + 체크 상태 복원
    try {
      const cap = localStorage.getItem(`${LS_PREFIX}:captured`)
      if (cap) { const p = JSON.parse(cap); if (p && typeof p === 'object') this.captured = p }
      const chk = localStorage.getItem(`${LS_PREFIX}:checked`)
      if (chk) { const p = JSON.parse(chk); if (p && typeof p === 'object') this.checked = p }
    } catch (e) { /* ignore */ }
    // 그룹 펼침 상태 복원 (없으면 모두 접힘)
    try {
      const saved = localStorage.getItem(`${LS_PREFIX}:group_open`)
      if (saved) {
        const parsed = JSON.parse(saved)
        if (parsed && typeof parsed === 'object') this.groupOpen = parsed
      }
    } catch (e) { /* ignore */ }
    // Auth(로그인) 그룹은 항상 펼쳐 노출 (로그인 우선 흐름)
    const authG = this.catalog.find(g => g.group.startsWith('Auth'))
    if (authG) this.$set(this.groupOpen, authG.group, true)
    // 마지막 선택 API 복원
    try {
      const lastName = localStorage.getItem(`${LS_PREFIX}:last_api`)
      if (lastName) {
        for (const g of this.catalog) {
          const a = g.apis.find(x => x.name === lastName)
          if (a) { this.selectApi(a); return }
        }
      }
    } catch (e) { /* ignore */ }
  },
}
</script>

<style scoped>
/* 폴더(그룹) 헤더 — 진한 배경으로 뚜렷이 구분 */
.api-group ::v-deep .v-list-group__header {
  background-color: #3b5a7f;      /* 진한 블루그레이 = 폴더 */
  border-radius: 6px;
  margin-top: 8px;
  min-height: 42px;
}
.api-group ::v-deep .v-list-group__header:hover {
  background-color: #32506f;
}
.api-group ::v-deep .v-list-group__header .v-list-item__title {
  font-weight: 700;
  color: #ffffff;
  letter-spacing: .2px;
}
.api-group ::v-deep .v-list-group__header .v-list-item__title .grey--text {
  color: #c8d6e8 !important;
}
.api-group ::v-deep .v-list-group__header .v-icon {
  color: #cddcf0 !important;
}
/* API 항목 — 미선택도 연한 톤 카드 */
.api-item {
  background-color: #eef2f8 !important;   /* 미선택 기본색 */
  border-left: 3px solid #cfd8e6;
  border-radius: 5px;
  margin: 3px 6px 3px 12px;
}
.api-item:hover {
  background-color: #e2ecfa !important;
  border-left-color: #7aa7d8;
}
.api-item.primary.lighten-5 {
  background-color: #cfe4fb !important;   /* 선택됨 */
  border-left-color: #1976d2;
}
</style>
